import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './customFieldsAndObjects.intl.json';

export const useCustomFieldsAndObjectsIntl = () => useIntlModule(messages);
